"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listenForNewMessages = listenForNewMessages;
exports.requestPermission = requestPermission;
exports.show = show;
var _lodash = _interopRequireDefault(require("lodash"));
let isEnabled = false;
function requestPermission(state) {
  // Do we support notifications?
  if (!('Notification' in window)) {
    isEnabled = false;
    return;
  }

  // Permissions already been granted?
  if (Notification.permission === 'granted') {
    state.$emit('notification.enabled');
    isEnabled = true;
    return;
  }
  if (Notification.permission !== 'denied') {
    Notification.requestPermission(permission => {
      if (permission === 'granted') {
        state.$emit('notification.enabled');
        isEnabled = true;
      } else {
        isEnabled = false;
      }
    });
  }
}
function show(title, body, opts) {
  if (!isEnabled) {
    return false;
  }
  let notify = new Notification(title, {
    body: body,
    icon: opts.icon
  });
  if (opts.ttl) {
    setTimeout(notify.close.bind(notify), opts.ttl);
  }
  return notify;
}
const throttledShow = _lodash.default.throttle(show, 2000);
function listenForNewMessages(state) {
  state.$on('notification.show', (message, _opts) => {
    if (!isEnabled) {
      return;
    }
    let opts = Object.assign({
      title: 'App IRC',
      message: message,
      icon: '',
      onclick: null,
      ttl: 10000
    }, _opts);
    if (!opts.message) {
      return;
    }
    let notification = throttledShow(opts.title, opts.message, {
      ttl: opts.ttl
    });
    if (notification && typeof opts.onclick === 'function') {
      notification.onclick = opts.onclick;
    }
  });
}
window._app_exports = window._app_exports || {};
if(!window._app_exports["libs"]) window._app_exports["libs"] = {};
window._app_exports["libs"]["Notifications"]
window._app_exports.libs.Notifications = exports.default ? exports.default : exports;
